(function () {
  const instances = new WeakMap();

  function initGsapSlider(root) {
    if (!root) return;
    if (root.dataset.gsapSliderInitialized === 'true') return;
    if (!window.gsap) return;

    const slides = Array.from(root.querySelectorAll('.scroll-section'));
    const nav = root.querySelector('.gsap-nav');
    if (!slides.length || !nav) return;

    root.dataset.gsapSliderInitialized = 'true';

    let current = 0;
    let isAnimating = false;
    let autoplayTimer = null;
    const AUTOPLAY_MS = 10000;

    const titles = slides.map((s, i) => s.dataset.title || `Slide ${i + 1}`);

    nav.innerHTML = '';

    titles.forEach((title, i) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = title;
      btn.setAttribute('aria-label', `Aller à ${title}`);
      btn.addEventListener('click', () => goTo(i, true));
      nav.appendChild(btn);
    });

    const navButtons = Array.from(nav.querySelectorAll('button'));

    function setActiveUI(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });

      navButtons.forEach((btn, i) => {
        btn.classList.toggle('is-active', i === index);
      });
    }

    function killAutoplay() {
      if (autoplayTimer) {
        clearTimeout(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function queueAutoplay() {
      killAutoplay();
      autoplayTimer = setTimeout(() => {
        goTo((current + 1) % slides.length, false);
      }, AUTOPLAY_MS);
    }

    function animateOut(slideEl) {
      const bgs = slideEl.querySelectorAll('.layer-bg');
      const product = slideEl.querySelector('.layer-product');
      const tl = gsap.timeline();

      tl.to(bgs, {
        yPercent: -106,
        opacity: 0,
        duration: 1.2,
        stagger: 0.1,
        ease: 'power3.in'
      }, 0);

      if (product) {
        tl.to(product, {
          yPercent: -106,
          opacity: 0,
          duration: 1.0,
          ease: 'power3.in'
        }, 0.2);
      }

      return tl;
    }

    function animateIn(slideEl) {
      const bg1 = slideEl.querySelector('.bg1');
      const bg2 = slideEl.querySelector('.bg2');
      const bg3 = slideEl.querySelector('.bg3');
      const bg4 = slideEl.querySelector('.bg4');
      const product = slideEl.querySelector('.layer-product');

      gsap.set([bg1, bg2, bg3, bg4].filter(Boolean), {
        yPercent: 106,
        opacity: 0
      });

      if (product) {
        gsap.set(product, {
          yPercent: 80,
          opacity: 0
        });
      }

      const tl = gsap.timeline();

      if (bg1) tl.to(bg1, { yPercent: 0, opacity: 1, duration: 0.8, ease: 'power3.out' }, 0);
      if (bg2) tl.to(bg2, { yPercent: 0, opacity: 1, duration: 0.8, ease: 'power3.out' }, 0.15);
      if (bg3) tl.to(bg3, { yPercent: 0, opacity: 1, duration: 0.8, ease: 'power3.out' }, 0.25);
      if (bg4) tl.to(bg4, { yPercent: 0, opacity: 1, duration: 0.8, ease: 'power3.out' }, 0.35);

      if (product) {
        tl.to(product, {
          yPercent: 0,
          opacity: 1,
          duration: 0.8,
          ease: 'power3.out'
        }, 0.35);
      }

      return tl;
    }

    function goTo(index, userInitiated) {
      if (isAnimating || index === current) return;

      isAnimating = true;
      killAutoplay();

      const prev = slides[current];
      const next = slides[index];

      setActiveUI(index);

      gsap.set(prev, { zIndex: 0, opacity: 1 });
      gsap.set(next, { zIndex: 1, opacity: 1 });

      const tl = gsap.timeline({
        onComplete: () => {
          gsap.set(prev, { opacity: 0 });
          current = index;
          isAnimating = false;
          queueAutoplay();
        }
      });

      tl.add(animateOut(prev), 0);
      tl.add(animateIn(next), 1.5);
    }

    function onMouseEnter() {
      killAutoplay();
    }

    function onMouseLeave() {
      queueAutoplay();
    }

    root.addEventListener('mouseenter', onMouseEnter);
    root.addEventListener('mouseleave', onMouseLeave);

    setActiveUI(0);

    slides.forEach((slide, i) => {
      gsap.set(slide, {
        zIndex: i === 0 ? 1 : 0,
        opacity: i === 0 ? 1 : 0
      });
    });

    animateIn(slides[0]);
    queueAutoplay();

    instances.set(root, {
      destroy() {
        killAutoplay();
        root.removeEventListener('mouseenter', onMouseEnter);
        root.removeEventListener('mouseleave', onMouseLeave);
        root.dataset.gsapSliderInitialized = 'false';
      }
    });
  }

  function destroyGsapSlider(root) {
    const instance = instances.get(root);
    if (instance && typeof instance.destroy === 'function') {
      instance.destroy();
    }
  }

  function initAllGsapSliders(container = document) {
    const roots = container.querySelectorAll('[data-gsap-slider]');
    roots.forEach(initGsapSlider);
  }

  // Initialisation au chargement normal
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllGsapSliders());
  } else {
    initAllGsapSliders(); // DOM déjà prêt (chargement synchrone)
  }

  // Initialisation différée (chargement lazy via IntersectionObserver)
  document.querySelectorAll('[data-gsap-slider]').forEach(function(root) {
    root.addEventListener('gsap-slider-init', function() {
      initAllGsapSliders();
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initAllGsapSliders(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-gsap-slider]');
    if (root) destroyGsapSlider(root);
  });
})();